module.exports = __webpack_public_path__ + "static/img/bcg_units.54510234.png";